import ProductCarousel from "./productCarousel";

const Index = (props) => {
  return (
    <div>
      <ProductCarousel id={props?.id} title={props?.title}/>
    </div>
  );
};

export default Index;
